import { BlocoForm } from '@presentation/components/organisms'
import { EditModal } from '@presentation/components/templates'
import { EditModalProps } from '@presentation/types/components/templates'

import { validationSchema } from './shared'

type Props = {
  id: string
  onEdit: () => void
}

const EditBlocoModal: React.FC<Props> = ({ id, onEdit }) => {
  const modalConfigs: EditModalProps = {
    id,
    path: '/blocos',
    formId: 'edit-bloco',
    nameForTitle: 'Bloco',
    validationSchema,
    mapRequest: data => ({
      nome: data.nome,
      eixo_id: data.eixo.id
    }),
    onEdit
  }

  return (
    <EditModal {...modalConfigs}>
      <BlocoForm />
    </EditModal>
  )
}

export default EditBlocoModal
